import React, { useState } from 'react'
import { Popup } from 'semantic-ui-react'
import {
  NewsWidgetCard,
  NewsTitle,
  NewsCarouselContainer,
  NewsCarouselTrack,
  NewsSection,
  NewsSectionTitle,
  NewsSectionDate,
  NewsSectionDescription,
  NewsActionsContainer,
  NewsActionButton,
  NewsCarouselButton,
  NewsCarouselHeader
} from './style'
import { NewsSectionType } from '../../mockData'
import { useTranslation } from 'react-i18next'
import CustomIcon from '~/components/CustomIcon'

interface NewsWidgetProps {
  data: NewsSectionType[]
}

const ITEMS_PER_VIEW = 3
const ITEM_WIDTH = 300

const NewsWidget: React.FC<NewsWidgetProps> = ({ data }) => {
  const { t } = useTranslation()
  const [currentIndex, setCurrentIndex] = useState(0)

  const maxIndex = Math.max(0, data.length - ITEMS_PER_VIEW)

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(maxIndex, prev + 1))
  }

  return (
    <NewsWidgetCard>
      <NewsCarouselHeader>
        <NewsTitle>{t('News')}</NewsTitle>
      </NewsCarouselHeader>

      <NewsCarouselContainer>

        <NewsCarouselButton
          className='left-carousel'
          onClick={handlePrev}
          disabled={currentIndex === 0}
        >
          <CustomIcon size={'large'} name='chevron left' />
        </NewsCarouselButton>

        <NewsCarouselButton
          className='right-carousel'
          onClick={handleNext}
          disabled={currentIndex >= maxIndex}
        >
          <CustomIcon size={'large'} name='chevron right' />
        </NewsCarouselButton>

        <NewsCarouselTrack style={{ transform: `translateX(-${currentIndex * ITEM_WIDTH}px)` }}>
          {data.map((section) => (
            <NewsSection key={section.id} $backgroundImage={section.backgroundImage}>
              <NewsSectionTitle>{section.title}</NewsSectionTitle>
              <NewsSectionDate>{section.date}</NewsSectionDate>
              {section.description && (
                <NewsSectionDescription>{section.description}</NewsSectionDescription>
              )}
              {section.actions.length > 0 && (
                <NewsActionsContainer>
                  {section.actions.map((action, index) => (
                    <Popup
                      key={index}
                      content={action.tooltip}
                      trigger={
                        action.download
                          ? <a href={action.url} download style={{ textDecoration: 'none' }}>
                            <NewsActionButton>{action.label}</NewsActionButton>
                          </a>
                          : <NewsActionButton>{action.label}</NewsActionButton>
                      }
                      position='top center'
                      inverted
                      size='small'
                    />
                  ))}
                </NewsActionsContainer>
              )}
            </NewsSection>
          ))}
        </NewsCarouselTrack>
      </NewsCarouselContainer>
    </NewsWidgetCard>
  )
}

export default NewsWidget
